module.exports = __webpack_public_path__ + "img/mall_logo.5be50745.png";